const CODE_TYPES = {
    SQL: { value: 1, label: 'PostgreSQL', mode: 'pgsql' },
    PYTHON: { value: 2, label: 'Python', mode: 'python' },
    MYSQL: { value: 3, label: 'MySQL', mode: 'mysql' },
    R: { value: 4, label: 'R', mode: 'r' },
    MSSQL: { value: 5, label: 'MSSQL', mode: 'sql' },
};
export default CODE_TYPES;
//# sourceMappingURL=consts.js.map